// the lead's approved "Signature Alief Funding Hub Background" — a cinematic black→crimson
// backdrop with chrome/crimson beams and a Great Vibes cursive "Alief Funding Hub"
// signature. Drop as the first child of a full-screen brand surface and add
// `has-signature-bg` to that surface so its content floats above (z-index 1).
export function SignatureBg() {
  return (
    <div className="bg-fx" aria-hidden="true">
      <span className="bg-sig">Alief Funding Hub</span>
    </div>
  );
}
